// extracted by mini-css-extract-plugin
module.exports = {"content":"page_layout-module__content--7qxng"};